import { PinnedMessage } from '@wui/im'

export const sortPinnedNewestFirst = (events: PinnedMessage[]) => {
  return [...events].sort((left, right) => (right.rank ?? 0) - (left.rank ?? 0))
}

export const sortPinnedOldestFirst = (events: PinnedMessage[]) => {
  return [...events].sort((left, right) => (left.rank ?? 0) - (right.rank ?? 0))
}
